module.exports = __webpack_public_path__ + "static/media/atom-512.1cdee5d6.png";